export const consumeEventEventName = "consume-event";
